import { Button } from '@app/components/various/Button';
import { Dropdown, DropdownMenu, DropdownTrigger } from '@app/components/various/Dropdown';
import { Sort } from '@app/components/various/Icons';
import { BREAKPOINTS } from '@app/constants/breakpoints';
import { useIsScreenSize } from '@app/utils/hooks';
import { Dropdown as DropdownType, Sorting } from '@typings';
import { useTranslation } from 'react-i18next';

import { SORT_BY_ARTICLE_NUMBER, SORT_BY_DELIVERY_WINDOW } from './constants';

interface Props {
  value: Sorting.FieldValue;
  onSelect: (value: Sorting.FieldValue) => void;
}

export const OrderProductsSorting = ({ onSelect, value }: Props) => {
  const { t } = useTranslation(['common']);
  const options: DropdownType.MenuItem[] = [
    {
      key: 'none',
      label: '-',
    },
    {
      key: SORT_BY_ARTICLE_NUMBER,
      label: t('common:art_number'),
    },
    {
      key: SORT_BY_DELIVERY_WINDOW,
      label: t('common:delivery_window_one'),
    },
  ];
  const isMobile = useIsScreenSize(BREAKPOINTS.SM);

  return (
    <Dropdown title={t('common:sort_by')}>
      <DropdownTrigger>
        {({ isOpen, triggerProps }) => (
          <Button
            size="medium"
            variant="bordered"
            color="secondary"
            icon={isMobile ? Sort : undefined}
            isChevronOpen={isOpen}
            {...triggerProps}
          >
            {!isMobile && t('common:sort_by')}
          </Button>
        )}
      </DropdownTrigger>
      <DropdownMenu
        selectionMode="single"
        selectedKeys={[value]}
        items={options}
        onSelectionChange={([newValue]) => onSelect(newValue as Sorting.FieldValue)}
      />
    </Dropdown>
  );
};
